module.exports = __webpack_public_path__ + "static/fonts/glyphicons-halflings-regular.e18bbf6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/self-diagnosis/font/glyphicons-halflings-regular.ttf
// module id = g1cl
// module chunks = 0